export default __webpack_public_path__ + "static/media/eusanyang.52e20ace.png";